<template>
  <div class="navigation">
    <a
      :href="pageData.urls.homeIndex"
      class="navigation__link"
    >
      {{ pageData.resourceStrings.linkHome }}
    </a>
    <span class="navigation__link-divider hidden-xs hidden-sm">&#x7c;</span>
    <a
      :href="pageData.urls.registrationIndex"
      class="navigation__link"
    >
      {{ pageData.resourceStrings.linkRegistration }}
    </a>
    <span class="navigation__link-divider hidden-xs hidden-sm">&#x7c;</span>
    <a
      class="navigation__link"
      href="https://www.teamphotonetwork.com/qpplus/search/bigpics"
    >
      {{ pageData.resourceStrings.linkHighSchoolPhotos }}
    </a>
    <span class="navigation__link-divider hidden-xs hidden-sm">&#x7c;</span>
    <a
      class="navigation__link"
      href="https://balfour.com"
    >
      {{ pageData.resourceStrings.linkBalfourDotCom }}
    </a>
    <span class="navigation__link-divider hidden-xs hidden-sm">&#x7c;</span>
    <a
      :href="pageData.urls.homeAboutUs"
      class="navigation__link"
    >
      {{ pageData.resourceStrings.linkAboutUs }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'SiteFooterNavigation',
  props: {
    pageData: { type: Object, default: null, required: true }
  }
}
</script>

<style lang="scss" scoped>
.navigation {
  margin: 0 0 20px;
  padding: 0 0 10px 0;
  border-bottom: 1px solid #d8dbde;

  @media screen and (min-width: $screen-md-min) {
    padding: 0;
    border-bottom: none;
    text-align: center;
  }

  @media screen and (min-width: $screen-lg-min) {
    text-align: left;
  }

  &__link {
    color: #535353;
    display: block;
    font-family: $font-circular-std;
    font-weight: normal;
    list-style: none;
    margin: 0 0 10px 0;
    padding: 0;
    text-align: left;

    & > a {
      color: #535353;
    }

    & > a:hover {
      color: #535353;
    }

    &:first-child {
      padding-left: 0;
    }

    @media screen and (min-width: $screen-md-min) {
      margin: 0 15px;
      display: inline-block;
      text-align: center;
      text-transform: uppercase;

      & > a {
        border-right: 2px solid #555;
        padding: 0 15px 0 0;
      }

      &:last-child > a {
        border-right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/site-footer/components/Navigation.vue